export enum PortfolioCategory {

    NATIONAL_NEWS_MEDIA = 'NATIONAL_NEWS_MEDIA',
    REGIONAL_NEWS_MEDIA = 'REGIONAL_NEWS_MEDIA',
    CULTURAL_NEWS_MEDIA = 'CULTURAL_NEWS_MEDIA',

    // Cultural news media
    BLACK_MEDIA = 'BLACK_MEDIA',
    HISPANIC_MEDIA = 'HISPANIC_MEDIA',
    INDIGENOUS_NORTH_AMERICAN_MEDIA = 'INDIGENOUS_NORTH_AMERICAN_MEDIA',

    LEADING_BY_SECTOR = 'LEADING_BY_SECTOR', // NOT a real category in the backend, just groups the ones below
    ENERGY_AND_ENVIRONMENT = 'ENERGY_AND_ENVIRONMENT',
    FINANCE = 'FINANCE',
    HEALTHCARE = 'HEALTHCARE',
    POLITICS = 'POLITICS',
    TECHNOLOGY = 'TECHNOLOGY',
    TRAVEL_AND_TOURISM = 'TRAVEL_AND_TOURISM'
}
